import * as React from 'react';

import {GridList} from 'shells/grid-list/grid-list';
import {OptionCardChooser} from 'shells/option-card-chooser/option-card-chooser';
import {SpacerGroup} from 'shells/spacer/spacer-group';
import {Subheader} from 'shells/typography/subheader';

import type {Audience} from 'nutshell-graphql-types';

import {appHistory} from '../../../../../history';

type Props = {
    audience: Audience;
    canImport?: boolean;
    onSelectImport: () => void;
};

export function Home(props: Props) {
    return (
        <React.Fragment>
            <SpacerGroup mb={8}>
                <Subheader>Add contacts that are already in Nutshell</Subheader>
            </SpacerGroup>
            <SpacerGroup mb={32}>
                <GridList numColumns={3}>
                    <OptionCardChooser
                        key='csv'
                        onClick={() => {
                            NutClientConfig.onboardingAudience = {
                                audienceName: props.audience.name,
                                audienceHtmlUrlPath: props.audience.htmlUrlPath,
                            };

                            appHistory.push('/people');
                        }}
                        illustration='audience-people'
                        title='People'
                        subtitle='Add people based on a specific set of criteria'
                    />
                    <OptionCardChooser
                        key='mailchimp'
                        onClick={() => {
                            NutClientConfig.onboardingAudience = {
                                audienceName: props.audience.name,
                                audienceHtmlUrlPath: props.audience.htmlUrlPath,
                            };

                            appHistory.push('/leads');
                        }}
                        illustration='audience-people-related-leads'
                        title='Leads'
                        subtitle='Add people related to a filtered list of leads'
                    />
                    <OptionCardChooser
                        key='ctct'
                        onClick={() => {
                            NutClientConfig.onboardingAudience = {
                                audienceName: props.audience.name,
                                audienceHtmlUrlPath: props.audience.htmlUrlPath,
                            };

                            appHistory.push('/companies');
                        }}
                        illustration='audience-people-related-companies'
                        title='Companies'
                        subtitle='Add people related to a filtered list of companies'
                    />
                </GridList>
            </SpacerGroup>
            {props.canImport !== false ? (
                <>
                    <SpacerGroup mb={8}>
                        <Subheader>Import new contacts into Nutshell</Subheader>
                    </SpacerGroup>
                    <GridList numColumns={1}>
                        <OptionCardChooser
                            key='other'
                            onClick={props.onSelectImport}
                            illustration='import-spreadsheet'
                            title='Import new contacts'
                            subtitle='Add contacts from a CSV spreadsheet or another email marketing tool'
                        />
                    </GridList>
                </>
            ) : undefined}
        </React.Fragment>
    );
}
